import { Icons } from './Icons';

type Props = { onClose: () => void };

export function RulesModal({ onClose }: Props) {
  return (
    <div
      className="fixed inset-0 z-[150] bg-black/60 flex items-center justify-center p-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 rounded-3xl shadow-2xl max-w-lg w-full border-4 border-green-500 relative max-h-[90vh] overflow-y-auto custom-scrollbar"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl font-bold"
        >
          ×
        </button>
        <h2 className="text-2xl font-black text-green-700 mb-4 text-center flex items-center justify-center gap-2">
          <Icons.Book /> 遊戲規則說明
        </h2>
        <div className="space-y-4 text-gray-700">
          <div className="bg-green-50 p-3 rounded-xl border border-green-200">
            <h3 className="font-bold text-green-800 mb-1">🏆 勝利條件</h3>
            <p className="text-sm">
              盡可能收集水果！當場上卡牌用完，或剩下最後一位農夫時遊戲結束。
            </p>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-blue-50 p-3 rounded-xl border border-blue-200">
              <h3 className="font-bold text-blue-800 mb-1">🃏 翻牌</h3>
              <p className="text-xs">每回合翻兩張，內容一樣就配對成功！</p>
            </div>
            <div className="bg-yellow-50 p-3 rounded-xl border border-yellow-200">
              <h3 className="font-bold text-yellow-800 mb-1">🛡️ 保護</h3>
              <p className="text-xs">被偷過的人會有暫時保護盾 (除非剩兩人)。</p>
            </div>
          </div>
          <div className="bg-orange-50 p-3 rounded-xl border border-orange-200">
            <h3 className="font-bold text-orange-800 mb-2">⚡ 行動策略 (配對成功後)</h3>
            <ul className="text-sm space-y-2">
              <li className="flex items-center gap-2">
                <span className="bg-green-500 text-white px-2 py-0.5 rounded text-xs">採收</span>{' '}
                自己 <span className="font-bold text-green-600">+2</span> 顆水果 (快速積累)
              </li>
              <li className="flex items-center gap-2">
                <span className="bg-orange-500 text-white px-2 py-0.5 rounded text-xs">偷竊</span>{' '}
                自己 <span className="font-bold text-green-600">+1</span>，對方{' '}
                <span className="font-bold text-red-600">-1</span> (攻擊對手)
              </li>
            </ul>
          </div>
          <div className="bg-red-50 p-3 rounded-xl border border-red-200 text-center">
            <p className="text-red-700 text-sm font-bold">💀 水果歸零就會被淘汰出局喔！</p>
          </div>
        </div>
        <button
          onClick={onClose}
          className="w-full mt-6 bg-green-600 hover:bg-green-700 text-white font-bold py-3 rounded-xl shadow-md btn-3d"
        >
          我知道了！
        </button>
      </div>
    </div>
  );
}
